import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { cn } from "../../lib/cn";

const ease = [0.16, 1, 0.3, 1];

/**
 * Shared layout for individual service detail pages: light page canvas + white card shell + subtle entrance.
 */
export default function ServicePageShell({ children, className }) {
  const reduceMotion = useReducedMotion();

  return (
    <section
      className={cn(
        "relative z-10 min-h-screen overflow-x-hidden bg-gradient-to-b from-[#F8F9FA] via-slate-100/40 to-[#F8F9FA] px-4 pb-12 pt-6 text-slate-700 sm:px-5 sm:pb-14 sm:pt-8",
        className
      )}
    >
      <motion.div
        initial={reduceMotion ? false : { opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: reduceMotion ? 0 : 0.45, ease }}
        className="mx-auto w-full min-w-0 max-w-5xl rounded-2xl border border-slate-200 bg-gradient-to-br from-white via-[#F8F9FA]/35 to-slate-50 px-4 py-8 shadow-[0_1px_3px_rgba(15,23,42,0.06),inset_4px_0_0_0_rgba(30,58,95,0.1)] sm:px-8 sm:py-10 md:px-12 md:py-14"
      >
        {children}
      </motion.div>
    </section>
  );
}
